/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { faCheckSquare, faSquare } from '@fortawesome/pro-regular-svg-icons';
import { ChecklistRecordData } from '../../../../../../../../models/record/items/checklist-record.model';

@Component({
  selector: 'checklist-record',
  templateUrl: './checklist-record.component.html',
  styleUrls: ['./checklist-record.component.scss'],
  standalone: false
})
export class ChecklistRecordComponent implements OnInit {
  @Input() record!: ChecklistRecordData;
  faCheckSquare = faCheckSquare;
  faSquare = faSquare;

  constructor() {}

  ngOnInit(): void {}
}
